(function () {
  'use strict';

  /* Progress Bar */
  var progressBar = document.querySelector('.blog-article-progress__bar');
  if (progressBar) {
    var ticking = false;
    function updateProgress() {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      if (scrollHeight > 0) {
        progressBar.style.width = Math.min((scrollTop / scrollHeight) * 100, 100) + '%';
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateProgress);
        ticking = true;
      }
    }, { passive: true });
  }

  /* TOC Generation */
  var prose = document.querySelector('.blog-post-content .prose, .blog-article-main .prose');
  var tocNav = document.querySelector('.blog-toc-card__nav');
  if (prose && tocNav) {
    var h2s = prose.querySelectorAll('h2');
    if (h2s.length === 0) {
      var tocCard = tocNav.closest('.blog-toc-card');
      if (tocCard) tocCard.style.display = 'none';
      return;
    }

    for (var i = 0; i < h2s.length; i++) {
      var h2 = h2s[i];
      if (!h2.id) {
        h2.id = 'section-' + (i + 1);
      }

      var li = document.createElement('li');
      li.textContent = (i + 1) + '. ' + h2.textContent.trim();
      li.setAttribute('data-target', h2.id);

      li.addEventListener('click', function () {
        var target = document.getElementById(this.getAttribute('data-target'));
        if (target) {
          var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });

      tocNav.appendChild(li);
    }

    /* IntersectionObserver for active highlighting */
    var tocItems = tocNav.querySelectorAll('li');
    if (tocItems.length > 0 && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          for (var e = 0; e < entries.length; e++) {
            if (entries[e].isIntersecting) {
              for (var t = 0; t < tocItems.length; t++) {
                tocItems[t].classList.remove('is-active');
              }
              var activeItem = tocNav.querySelector('[data-target="' + entries[e].target.id + '"]');
              if (activeItem) {
                activeItem.classList.add('is-active');
              }
            }
          }
        },
        { rootMargin: '-80px 0px -70% 0px' }
      );

      for (var j = 0; j < h2s.length; j++) {
        observer.observe(h2s[j]);
      }
    }
  }
})();
